import { PhotoData } from "../../photo/interfaces/dto";

export default function resizeShimmer(
	popup: HTMLElement,
	photoData: PhotoData,
) {
	const { findHtmlEl } = pm.utils.dom;

	const shimmer = findHtmlEl(popup, ".loading-shimmer");
	if (!shimmer) return;

	const photoWrapper = findHtmlEl(popup, ".single-image-wrapper");
	if (!photoWrapper) return;

	const shimmerHeight = calculateShimmerHeight(
		photoWrapper,
		photoData.width,
		photoData.height,
	);

	shimmer.style.height = shimmerHeight + "px";
}

function calculateShimmerHeight(
	photoWrapper: HTMLElement,
	photoWidth: number,
	photoHeight: number,
) {
	const photoWrapperWidth = photoWrapper.offsetWidth;
	const widthRatio = photoWrapperWidth / photoWidth;

	return photoHeight * widthRatio;
}
